import useDisclosure, { DisclosureHost } from "./use-disclosure";

type GreaterThanOne<T extends number> = T extends 1 | 0 ? never : T;

/**
 * @summary this hook is build on Top of Disclosure hook `to reduce multiple disclosure initialization`
 * - it manage initialization  internally to reduce code and return `DisclosureHost`
 * 
 * @param closureCount
 * @returns {DisclosureHost} DisclosureHost
 * @author rajkumar rathod
 */
export const useReduceDisclosure = <T extends number>(
  closureCount: GreaterThanOne<T>
): DisclosureHost[] => {
  return Array.from({ length: closureCount }).map(() => useDisclosure(false));
};
